import { Outlet } from "react-router-dom";

import { AdminShell } from "../../../widgets/admin-shell";

export const PrivateLayout: React.FC = () => {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
};
